import React, {useContext, useEffect} from "react";
import PageTitle from "./include/PageTitle";
import {Store} from "../Utils/Store";
import ContactForm from "./include/ContactForm";
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";

function Contact({title}) {
    const {state} = useContext(Store)
    const {ContactInfo} = state
    return (
        <div>
            <Helmet>
                <title>Zaala | Contact</title>
            </Helmet>
            <PageTitle title={title}/>

            <section className="contact-page py-0">
                <div className="container">
                    <div className="row">
                        {/*Start Contact Page Contact Info*/}
                        <div className="col-xl-12 col-lg-4">
                            <div className="contact-page__contact-info">
                                <div className="title-box">
                                    <h2>Get in Touch</h2>
                                    <p>
                                        Have questions or need tailored solutions? Reach out to us! Our team is ready to
                                        support your journey from concept to launch with expertise and dedication. Let’s
                                        discuss how we can bring your vision to life.
                                    </p>

                                </div>
                                <ul className="d-flex list-unstyled">
                                    <li className="me-4">
                                        <div className="icon-box">
                                            <span className="icon-pin"></span>
                                        </div>
                                        <div className="text-box">
                                            <h3>Address</h3>
                                            <p>
                                                {ContactInfo.address}
                                            </p>
                                        </div>
                                    </li>
                                    <li className="me-4">
                                        <div className="icon-box">
                                            <span className="icon-envelope"></span>
                                        </div>
                                        <div className="text-box">
                                            <h3>Email Address</h3>
                                            <p>
                                                <Link
                                                    to={`mailto:${ContactInfo.contact_email}`}>{ContactInfo.contact_email}</Link>
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon-box">
                                            <span className="icon-call"></span>
                                        </div>
                                        <div className="text-box">
                                            <h3>Phone number</h3>
                                            <p>
                                                <Link
                                                    to={`tel:${ContactInfo.contact_phone}`}>{ContactInfo.contact_phone} </Link>
                                            </p>
                                        </div>
                                    </li>
                                </ul>

                            </div>
                        </div>
                        {/*End Contact Page Contact Info*/}
                    </div>
                </div>
            </section>


            <section className="contact-one">
                <div
                    className="contact-one__bg"
                    style={{backgroundImage: "url(assets/img/bg/contact-v1-bg.jpg)"}}
                />
                <div className="container">
                    <div className="contact-one__inner clearfix">
                        <div
                            className="contact-one__form wow fadeInRight"
                            data-wow-delay="200ms"
                            data-wow-duration="1500ms"
                            style={{
                                visibility: "visible",
                                animationDuration: "1500ms",
                                animationDelay: "200ms",
                                animationName: "fadeInRight"
                            }}
                        >
                            <div className="section-title tg-heading-subheading animation-style2">
                                <h5 className="tg-element-title" style={{perspective: 400}}>
                                    <div
                                        className="split-line"
                                        style={{
                                            display: "block",
                                            textAlign: "start",
                                            position: "relative"
                                        }}
                                    >
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                T
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                a
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                l
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                k
                                            </div>
                                        </div>
                                        {" "}
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                t
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                o
                                            </div>
                                        </div>
                                        {" "}
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                u
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                s
                                            </div>
                                        </div>
                                    </div>
                                </h5>
                                <h2 className="tg-element-title" style={{perspective: 400}}>
                                    <div
                                        className="split-line"
                                        style={{
                                            display: "block",
                                            textAlign: "start",
                                            position: "relative"
                                        }}
                                    >
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                U
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                n
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                l
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                e
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                a
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                s
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                h
                                            </div>
                                        </div>
                                        {" "}
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                t
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                h
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                e
                                            </div>
                                        </div>
                                        {" "}
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                P
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                o
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                w
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                e
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                r
                                            </div>
                                        </div>
                                        {" "}
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                o
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                f
                                            </div>
                                        </div>
                                        {" "}
                                    </div>
                                    <div
                                        className="split-line"
                                        style={{
                                            display: "block",
                                            textAlign: "start",
                                            position: "relative"
                                        }}
                                    >
                                        <div style={{position: "relative", display: "inline-block"}}>
                                            {" "}
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                T
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                e
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                c
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                h
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                n
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                o
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                l
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                o
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                g
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    transform: "translate(0px, 0px)",
                                                    opacity: 1
                                                }}
                                            >
                                                y
                                            </div>
                                        </div>
                                    </div>
                                </h2>
                            </div>
                            <ContactForm/>
                        </div>
                    </div>
                </div>
            </section>


            <section className="google-map-one py-0 my-0">
                <iframe
                    src="https://www.google.com/maps?q=Al+Malaz,+Riyadh,+Saudi+Arabia&output=embed"
                    title="Al Malaz, Riyadh, Saudi Arabia"
                    className="google-map-one__map"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    allowFullScreen=""
                />

            </section>

        </div>
    );
}

export default Contact;
